import KdTooltip from '@kdocs/kdesign-vue/lib/tooltip';

// 一种省略单行文本的组件。用于省略单行文本中的中间片段。在显示宽度受到限制的空间中，它可以显示字符串的头部和尾部。通过这种方式，将更容易推断出字符串的含义
var VueAbbr = {
  render: function render() {
    var _vm = this;
    var _h = _vm.$createElement;
    var _c = _vm._self._c || _h;
    return _c('div', {
      staticClass: "abbre",
      attrs: {
        "title": _vm.hasTips ? '' : _vm.text
      }
    }, [_vm.isRTL ? [_c('span', {
      staticClass: "abbre-front"
    }, [_vm._v(_vm._s(_vm.text))])] : _vm.hasTips ? _c('kd-tooltip', {
      staticClass: "abbre-tooltip",
      attrs: {
        "popperClass": _vm.tipsClass,
        "openDelay": 400,
        "content": _vm.text
      }
    }, [_c('span', [_c('span', {
      "class": _vm.$ua.isiPad ? 'ipad-abbre-front' : 'abbre-front'
    }, [_vm._v(_vm._s(_vm.front))]), _vm._v(" "), _c('span', {
      "class": ['abbre-behind', _vm.isLastSpace ? 'abbre-behind-pad' : '']
    }, [_vm._v(_vm._s(_vm.behind))])])]) : [_c('span', {
      staticClass: "abbre-front"
    }, [_vm._v(_vm._s(_vm.front))]), _vm._v(" "), _c('span', {
      staticClass: "abbre-behind"
    }, [_vm._v(_vm._s(_vm.behind))])]], 2);
  },
  staticRenderFns: [],
  name: 'VueAbbr',
  components: {
    KdTooltip: KdTooltip
  },
  props: {
    text: {
      type: String,
      required: true
    },
    cut: {
      type: Number,
      "default": 50
    },
    hasTips: {
      type: Boolean,
      "default": false
    },
    tipsClass: {
      type: String,
      "default": ''
    }
  },
  data: function data() {
    // 适配右排布局
    return {
      isRTL: false
    };
  },
  computed: {
    front: function front() {
      return this.text.substring(0, Math.floor(this.cut / 100 * this.text.length));
    },
    behind: function behind() {
      var behind = this.text.substring(Math.floor(this.cut / 100 * this.text.length), this.text.length);
      return this.replaceS(behind.split('').reverse());
    }
  },
  mounted: function mounted() {
    var _this = this;
    // 适配右排布局
    this.$nextTick(function () {
      _this.isRTL = document.documentElement.getAttribute('dir') === 'rtl';
    });
  },
  methods: {
    replaceS: function replaceS(str) {
      var reg = '<>《》（）(){}[]【】「」『』〔〕﹛﹜«»［］‹›〈〉〖〗＜＞﹝﹞｛｝';
      for (var ind in str) {
        var val = str[ind];
        var mind = reg.indexOf(val);
        if (mind !== -1) {
          switch (mind) {
            case 0:
              str[ind] = '>';
              break;
            case 1:
              str[ind] = '<';
              break;
            case 2:
              str[ind] = '》';
              break;
            case 3:
              str[ind] = '《';
              break;
            case 4:
              str[ind] = '）';
              break;
            case 5:
              str[ind] = '（';
              break;
            case 6:
              str[ind] = ')';
              break;
            case 7:
              str[ind] = '(';
              break;
            case 8:
              str[ind] = '}';
              break;
            case 9:
              str[ind] = '{';
              break;
            case 10:
              str[ind] = ']';
              break;
            case 11:
              str[ind] = '[';
              break;
            case 12:
              str[ind] = '】';
              break;
            case 13:
              str[ind] = '【';
              break;
            case 14:
              str[ind] = '」';
              break;
            case 15:
              str[ind] = '「';
              break;
            case 16:
              str[ind] = '』';
              break;
            case 17:
              str[ind] = '『';
              break;
            case 18:
              str[ind] = '〕';
              break;
            case 19:
              str[ind] = '〔';
              break;
            case 20:
              str[ind] = '﹜';
              break;
            case 21:
              str[ind] = '﹛';
              break;
            case 22:
              str[ind] = '»';
              break;
            case 23:
              str[ind] = '«';
              break;
            case 24:
              str[ind] = '］';
              break;
            case 25:
              str[ind] = '［';
              break;
            case 26:
              str[ind] = '›';
              break;
            case 27:
              str[ind] = '‹';
              break;
            case 28:
              str[ind] = '〉';
              break;
            case 29:
              str[ind] = '〈';
              break;
            case 30:
              str[ind] = '〗';
              break;
            case 31:
              str[ind] = '〖';
              break;
            case 32:
              str[ind] = '＞';
              break;
            case 33:
              str[ind] = '＜';
              break;
            case 34:
              str[ind] = '﹞';
              break;
            case 35:
              str[ind] = '﹝';
              break;
            case 36:
              str[ind] = '｝';
              break;
            case 37:
              str[ind] = '｛';
              break;
          }
        }
      }
      return str.join('');
    }
  }
};

VueAbbr.install = function (Vue) {
  Vue.component(VueAbbr.name, VueAbbr);
};

export { VueAbbr as default };
